import { combineReducers } from "@reduxjs/toolkit";
import user from "./slices/user";

export default combineReducers({ user });
